import React, { Component } from 'react';
import { userLogout } from '../../common/globals';

class SessionExpireMessageModal extends Component {
  _onOK = async () => {
    await userLogout(true);
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="sessionExpireMessageModal"
        tabIndex="-1" aria-labelledby="sessionExpireMessageModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="sessionExpireMessageModalLabel">OPtimize</h5>
              <p>Your session has expired.</p>
              <p>Please login again.</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button
                    type="button" className="btn btn-link alert-modal-btn w-100"
                    data-bs-dismiss="modal"
                    onClick={this._onOK}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SessionExpireMessageModal;
